import axios from 'axios';

export function stripHtmlToPlain(html) {
  if (typeof document !== 'undefined') {
    const div = document.createElement('div');
    div.innerHTML = html || '';
    return (div.textContent || div.innerText || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }
  return String(html || '')
    .replace(/\s*<br\s*\/?>\s*/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function escapeHtml(text) {
  return String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function normalizeAiPlainText(text) {
  return String(text || '')
    .replace(/\s*<br\s*\/?>\s*/gi, '\n')
    .replace(/<\/p>\s*<p[^>]*>/gi, '\n\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<p[^>]*>/gi, '')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/\r\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function plainTextToQuillHtml(text) {
  const raw = normalizeAiPlainText(text);
  if (!raw) return '<p><br></p>';

  const paras = raw.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
  if (!paras.length) return '<p><br></p>';

  return paras
    .map((p) => `<p>${escapeHtml(p).replace(/\n/g, '<br>')}</p>`)
    .join('');
}

export function buildIncomingEmailPayload(email) {
  if (!email) return null;
  const body =
    String(email.text || '').trim() ||
    stripHtmlToPlain(email.html || email.bodyHtml || '');
  return {
    from: String(email.from || '').trim(),
    subject: String(email.subject || '').trim(),
    body: body.slice(0, 12000),
  };
}

export async function requestEmailAssist({ mode, incoming, draft }) {
  const res = await axios.post('/api/ai/email-assist', {
    mode,
    incoming: incoming || undefined,
    draft: draft || undefined,
  });
  if (!res.data?.success || !String(res.data?.text || '').trim()) {
    throw new Error(res.data?.error || 'KI-Antwort leer');
  }
  return String(res.data.text).trim();
}

export function applyHtmlToComposer({
  html,
  composerHtmlRef,
  setComposerData,
  setComposerEditorKey,
}) {
  const next = html || '<p><br></p>';
  if (composerHtmlRef) composerHtmlRef.current = next;
  if (typeof setComposerData === 'function') {
    setComposerData((prev) => ({ ...prev, html: next }));
  }
  if (typeof setComposerEditorKey === 'function') {
    setComposerEditorKey((k) => k + 1);
  }
}
